import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { StatusPanel } from "../components/StatusPanel";
import { invokeFunction, supabase } from "../lib/supabase";

export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    async function finish() {
      if (!supabase) return setError("Backend is not configured.");
      const { data, error: sessionError } = await supabase.auth.getSession();
      if (sessionError || !data.session) return setError("Discord sign-in did not finish.");
      const returnTo = sessionStorage.getItem("discord-oauth-return-to");
      if (returnTo === "/apply") {
        sessionStorage.removeItem("discord-oauth-return-to");
        navigate("/apply", { replace: true });
        return;
      }
      try {
        const result = await invokeFunction<{ allowed: boolean; role: string }>("discord-onboarding", {
          providerToken: data.session.provider_token,
        });
        if (!result.allowed) return setError("This Discord account does not have approved member access.");
        navigate(result.role === "admin" ? "/admin" : "/app", { replace: true });
      } catch (callbackError) {
        setError(callbackError instanceof Error ? callbackError.message : "Could not verify membership.");
      }
    }
    void finish();
  }, [navigate]);

  return <main className="login-shell"><section className="login-card">{error ? <StatusPanel title="Access blocked" message={error} kind="error" /> : <><span className="eyebrow">DISCORD</span><h1>Checking your access…</h1></>}</section></main>;
}
